import { render } from "./notaSuCliente.vue?vue&type=template&id=eaffddca&ts=true"
import script from "./notaSuCliente.vue?vue&type=script&lang=ts"
export * from "./notaSuCliente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__